import { decodeHTML } from 'entities'

export const fixTitle = str => {
  return decodeHTML(str).replace('–', '-')
}
